"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkerCacheUtils = exports.NetworkerCacheUtils = void 0;
var NetworkerCacheUtils = /** @class */ (function () {
    function NetworkerCacheUtils() {
    }
    NetworkerCacheUtils.prototype.getMatchIndex = function (url, params, networkerCacheData) {
        var _this = this;
        var cacheIndex = -1;
        networkerCacheData.forEach(function (item, index) {
            if (item.url === url && _this.compare(item.requestOptions, params)) { // && Object.is(item.cacheRequest.requestOptions, params)
                cacheIndex = index;
            }
        });
        return cacheIndex;
    };
    NetworkerCacheUtils.prototype.compare = function (a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    };
    return NetworkerCacheUtils;
}());
exports.NetworkerCacheUtils = NetworkerCacheUtils;
exports.networkerCacheUtils = new NetworkerCacheUtils();
//# sourceMappingURL=networker-cache-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/networker/lib/networker-cache-utils.js
// module id = 1197
// module chunks = 8